<template>
    <div class="agreeWrap">
      
      <div>
        <h1>用户服务协议</h1>
        <div class="bd">
          <p>导言：</p>
          <p>欢迎您使用本软件及服务！</p>
          <p>
            为使用本平台提供的软件及服务（以下简称“本软件”或“本服务”），您应当阅读并遵守《用户服务协议》（以下简称“本协议”）以及服务的各项制度规范等。
          </p>
          <p>
            请您务必谨慎阅读、充分理解各条款内容，特别是免除或限制责任的相应条款，以及开通或使用某项服务的单独协议，并选择接受或不接受。限制、免责条款已以加粗形式提示您注意。
          </p>
          <p>
            除非您已阅读并接受本协议所有条款，否则您无权使用本软件及相关服务。您的下载、安装、使用、获取账号、登录等行為（以下统称为“使用”）即视為为您已阅读并同意上述协议的约束。
          </p>
          <p>
            您有违反本协议的任何行为时，本平台有权依照违反情况，随时单方限制、中止或终止向您提供本服务，并有权追究您的相关责任。
          </p>
          <p>
            如果您未满18周岁，请在监护人的陪同下阅读本协议及其他上述协议，并特别注意未成年人使用条款。
          </p>
          <h6>一、特別提示</h6>
          <ol class="list decimal-list">
            <li>
              本平台同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务(以下称“网络服务”)。为获得本服务，用户同意本协议的全部条款并通过运营商正规渠道获取的手机号码进行账号註册。注册过程中需进行短信验证并绑定一个有效的手机号码，点击“登录”按钮即表示用户已经详细阅读了本协议的内容，同意遵守本协议的约定。用户不应再以不了解本协议内容為由拒绝履行本协议。本平台有权对本协议随时进行修改与更新，并在相关官方网站公告新协议内容。修改后的服务协议一旦在页面上公布即有效代替原来的服务协议。请用户随时造访本软件内“账号登录”界面以及“关于我们”页面查看本协议的最新版本。用户在使用本平台提供的各项服务之前，应仔细阅读本服务协议，如用户不同意本服务协议及/或随时对其的修改，用户可以主动取消本平台提供的网络服务。
            </li>
          </ol>
          <h6>二、定义</h6>
          <ol class="list decimal-list">
            <li>
              1.本软件：是指本软件所属公司（以下简称“公司”）向用户提供的读书工具，支持软件内置书城书籍的阅读，同时为用户提供包括但不限于书籍推荐、好友分享等功能或内容的软件许可及服务的客户端软件，在本协议中简称“本软件”。
            </li>
            <li>
              2.用户：是指启用、浏览或上传数据至本软件服务的用户，在本协议中更多地称为“您”。
            </li>
            <li>
              3.其他用户：是指除用户本人外与本软件服务相关的其他本软件用户。
            </li>
          </ol>
          <h6>三、协议的范围</h6>
          <ol class="list decimal-list">
            <li>
              1.本协议是您与本平台之间关于用户下载、安装、使用本软件，以及使用本软件相关服务所订立的协议。
            </li>
            <li>
              2.本协议内容同时包括本平台可能不断发布的关于本服务的相关协议、服务声明、业务规则及公告指引等内容（包括但不限于《本软件用户个人信息保护及隐私政策协议》等）。上述内容一经正式发布，即为本协议不可分割的组成部分，您同样应当遵守。
            </li>
          </ol>
          <h6>四、关于本软件</h6>
          <ol class="list decimal-list">
            <li>
              服务许可
              <ul class="list">
                <li>1.1本软件可能提供多个应用版本，用户必须选择与所安装设备相匹配的软件版本。用户可根据本协议获得以下许可：</li>
                  <ul class="list textIndet10">
                  <li>
                    （1.1.1）本平台给予您一项个人的、不可转让及非排他性的许可，以使用本软件。您可以為非商业目的在单一台终端设备上安装、使用、显示、运行本软件。
                  </li>
                  <li>
                    （1.1.2）本条及本协议其他条款未明示授权的其他一切权利仍由本平台保留，您在行使这些权利时须另外取得本平台的书面许可。本平台如果未行使前述任何权利，并不构成对该权利的放弃。
                  </li>
                </ul>
              </ul>
            </li>
            <li>
              安装与卸载
              <ul class="list">
                <li>
                  2.1您可以直接从本软件官网获取本软件，也可以从得到本平台授权的第三方获取。如果您从未经本平台授权的第三方获取本软件或与本软件名称相同的安装程序，本平台无法保证本软件能够正常使用，并对因此给您造成的损失不予负责。
                </li>
                <li>
                  2.2本平台可能为不同的终端设备开发了不同的软件版本，您应当根据实际情况选择下载合适的版本进行安装。下载安装程序后，您需要按照该程序提示的步骤正确安装。為提供更加优质、安全的服务，在本软件安装时本平台可能推荐您安装其他软件，您可以选择安装或不安装。
                </li>
                <li>
                  2.3如果您不再需要使用本软件或者需要安装新版软件，可以自行卸载。如果您愿意帮助本软件改进产品服务，请告知卸载的原因。
                </li>
                <li>
                  2.4为了改善用户体验、完善服务内容，本平台将不断努力开发新的服务，并为您不时提供软件更新（这些更新可能会採取软件替换、修改、功能强化、版本升级等形式）。为了保证本软件安全性和功能的一致性，本平台有权不经向您特别通知而对软件进行更新，或者对软件的部分功能效果进行改变或限制。本软件新版本发布后，旧版本的软件可能无法使用。本平台不保证旧版本软件继续可用及相应的客户服务，请您随时核对并下载最新版本。
                </li>
              </ul>
            </li>
          </ol>
          <h6>五、用户个人信息保护及隐私政策</h6>
          <ol class="list decimal-list">
            <li>1.本平台将按照本协议及《本软件用户个人信息保护及隐私政策协议》的规定收集、储存和使用用户的个人信息。本协议对个人信息保护规定的内容与上述《本软件用户个人信息保护及隐私政策协议》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《本软件用户个人信息保护及隐私政策协议》的内容为准。</li>
            <li>2.用户在注册账号或使用本服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，用户需要填写真实、完整、有效的身份信息，依据相关法律规定和本协议约定对所提供的信息承担相应的法律责任。若用户填写的信息不完整或提供的资料已变更未更新，则无法使用本服务或在使用过程中受到限制，本平台不因此承担任何责任。</li>
            <li>3.本平台保证不对外公开或向第三方（除本协议另有约定外）提供用户註册资料及用户在使用网络服务时存储在本平台的非公开内容，但下列情况除外：
              <ul class="list">
                <li>（3.1）事先获得用户的明确授权；</li>
                <li>（3.2）根据有关的法律法规要求；</li>
                <li>（3.3）按照相关政府主管部门的要求；</li>
                <li>（3.4）为维护社会公众的利益；</li>
                <li>（3.5）为维护本平台的合法权益。</li>
              </ul>
            </li>
            <li>4.在不透露单个用户隐私资料的前提下，本平台有权对整个用户数据库进行技术分析并对已进行分析、整理后的用户数据库进行商业上的利用。</li>
            <li>5.本平台将运用各种安全技术和程序建立完善的管理制度来保护您的个人信息，以免遭受未经授权的访问、使用或披露。您能理解，本平台对用户的隐私权保护做了极大的努力，但是仍然不能保证现有的安全技术措施使用户的技术信息等不受任何形式的损失。</li>
            <li>6.本平台非常重视对未成年人个人信息的保护。若用户是18周岁以下的未成年人，在使用本平台的服务前，应事先取得家长或法定监护人（以下简称“监护人）的书面同意；若父母（监护人）希望未成年人（尤其是十岁以下子女）得以使用服务的，须以父母（监护人）名义申请注册，在接受网络服务时，应以父母（监护人）身份加以判断本服务是否符合于未成年人。</li>
          </ol>
          <h6>六、用户注意事项</h6>
          <ol class="list decimal-list">
            <li>
              1.您理解并同意，如您在使用本服务时未使用相关账户登录，由此引发的任何问题，本平台概不负责。
            </li>
            <li>
              2.您理解并同意，为了向您提供有效的服务，本软件会利用您设备终端的处理器和带宽等资源。本软件使用过程中可能产生数据流量的费用，用户需自行向运营商了解相关资费信息，并自行承担相关费用。
            </li>
            <li>
              3.您在使用本软件某一特定服务时，该服务可能会另有单独的协议、专项规则等，您在使用该项服务前请阅读并同意相关的单独协议、专项规则。
            </li>
  
            <li>4.您理解并同意本平台将会尽其商业上的合理努力保障您在本软 件中的数据存储安全，但是，本平台并不能就此提供完全保证，包括但不限于以下情形：
              <ul class="list textIndet10">
                <li>（4.1）本平台不对您在本软件中相关数据的删除或储存失败负责；
                </li>
                <li>（4.2）如果您停止使用本软件超过一年或服务被终止或取消的，本平台可以从服务器上永久地删除您的数据，也没有义务向您返还任何数据。
                </li>
                <li>（4.3）用户在使用本软件时，须自行承担如下本平台不可掌控的风险内容，包括但不限于：
                  <ul class="list textIndet20">
                    <li>（4.3.1）由于信息网络设备维护、连接故障，系统故障，电力故障，罢工，暴乱，火灾，洪水，风暴，爆炸，战争，政府行为，司法行政机关的命令或因第三方因素可能引起的个人信息丢失、泄露及其他损害等风险；
                    </li>
                    <li>（4.3.2）如使用本客户端软件，用户必须选择与所安装设备相匹配的软件版本，否则，由于软件与设备型号不相匹配所导致的任何问题或损害，均由用户自行承担；
                    </li>
                    <li>（4.3.3）用户发布的内容或您的软件使用信息（包括但不限于使用本服务所产生的您的书架、用户评论等信息）被他人转发、分享，因此等传播可能带来的风险和责任；
                    </li>
                    <li>（4.3.4）由于网络信号不稳定、网络带宽小等原因，所引起的本软件登录失败、资料同步不完整、页面打开速度慢等风险。
                    </li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>5.服务变更、中断或终止
              <ul class="list textIndet10">
                <li>（5.1）用户接受、使用或在相关更新条款发布后继续使用本软件的行为，视为接受并认可相关条款的法律效力及对双方的约束力，且用户认可相关条款（包括但不限于任何更新后的条款）具有溯及至该用户账号首次登陆本软件之日的法律效力并在该日起对双方有共同的约束力。
                </li>
                <li>（5.2）用户在接受本服务时实施不正当行为的，本平台有权终止对用户提供服务，该不当行为包括但不限于违约、违法、违反公序良俗、侵犯本平台或任何第三方之权益等。
                </li>
                <li>（5.3）用户在接受本服务时实施本协议中有明确约定或属於本平台事先明确告知的应被终止服务的禁止性行為的，本平台有权终止对用户提供服务。
                </li>
                <li>（5.4）用户利用本软件进行洗钱、预付卡套现、购买等违法行为的，本平台有权在不事先通知用户的情况下中止或终止部分或全部网络服务的权利。
                </li>
                <li>（5.5）如用户传播本软件作品章节相关内容的图档、文字，或有其他违反有关法律、法规或本协议项下的任何条款，而给本平台或任何其他第三人造成损失；或者因用户自身过错导致本人账号或密码洩泄露，而给本平台或任何其他第三人造成损失的，本平台将终止向用户提供本协议项下的网络服务，无需通知用户，并不退回相关账号剩余金额。
                </li>
                <li>（5.6）如因系统维护或升级的需要而需暂停服务，本平台将尽可能事先进行通告。
                </li>
                <li>（5.7）如因突发性网络设备故障、网络设备因不明原因停止、不可抗力、相关政府机构要求及其他情况，发生未能事先通知用户的服务部分或全部中断或终止，造成的任何损失，本平台无需对用户或任何第三方承担责任。
                </li>
              </ul>
            </li>
            <li>6.广告
              <ul class="list textIndet10">
                <li>（6.1）您同意本平台可以在提供服务的过程中自行或由第三方广告商通过电子邮件或其他方式向您发送广告、推广或宣传信息（包括商业与非商业信息）。
                </li>
                <li>（6.2）您同意，本平台在提供服务的过程中以各种形式投放商业性广告或其他任何类型的商业性信息，是本平台为所有用户提供综合（免费）服务的有效对价，您接收本平台服务即视为对该规则的理解和接受。
                </li>
                <li>（6.3）本平台依照法律的规定履行相关义务，您应当自行判断广告信息的真实性并为自己的判断行為负责，除法律明确规定外，您因依该广告信息进行的交易或前述广告商提供的内容而遭受的损失或损害，本平台不承担责任。
                </li>
                <li>（6.4）您同意，对本软件中出现的广告信息，您应审慎判断其真实性和可靠性，除法律明确规定外，您应对依该广告信息进行的交易负责。
                </li>
                <li>
                  （6.5）您理解并同意，非正当屏蔽本平台所提供的广告将给本平台造成极大的损失，因此您不会主动採取非正当手段屏蔽广告内容。
                </li>
              </ul>
            </li>
            <li>
              7.关于单项服务的特殊约定
              <ul class="list textIndet10">
                <li>
                  （7.1）本软件及相关服务中包含公司以各种合法方式获取的信息或信息内容链接，同时也包括公司及其关联方合法运营的其他单项服务。
                </li>
                <li>
  
                  （7.2）您可以在本软件中开启和使用单项服务。某些单项服务可能需要您同时接受就该单项服务特别指定的协议或者其他约束您与该单项服务提供者之间的规则。公司将在您计划使用前述单项服务时以醒目的方式向您提供这些协议、规则，供您查阅与同意。一旦您开始使用上述服务，则视为您就理解并接受有关单项服务的相关协议、规则的约束。
                </li>
                <li>
                  （7.3）在用户使用平台服务的同时，本平台将会附赠金币奖励、现金奖励等除阅读之外的服务，但该等服务均为随号赠送福利。如本平台根据自身技术排查，发现任何滥用金币奖励、现金奖励等福利的任何作弊的行为，或对数据产生重大质疑，均可以判定用户本次参加活动的行为无效，取消该账户所有福利，甚至封禁该账户。
                </li>
              </ul>
            </li>
            <li>
              8.第三方产品和服务
              <ul class="list textIndet10">
                <li>
                  （8.1）您在使用本软件第三方提供的产品或服务时，除遵守本协议约定外，还应遵守第三方的用户协议。本平台和第三方对可能出现的纠纷在法律规定和约定的范围内各自承担责任。
                </li>
                <li>
                  （8.2）因用户使用本软件或要求本平台提供特定服务时，本软件可能会调用第三方系统或者通过第三方支持用户的使用或访问，使用或访问的结果由该第三方提供，本平台不保证通过第三方提供服务及内容的安全性、准确性、有效性及其他不确定的风险，由此若引发的任何争议及损害，与本平台无关，本平台不承担任何责任。
                </li>
              </ul>
            </li>
          </ol>
          <h6>九、知识产权声明</h6>
          <ol class="list decimal-list">
            <li>1.本软件的一切著作权、商标权、专利权、商业秘密等知识产权，以及与本软件相关的所有信息内容（包括但不限于文字、图片、音频、视频、图表、界面设计、版面框架、有关数据或电子文档等）均受相应法律法规和国际条约保护，本平台享有上述知识产权，但相关权利人依照法律规定应享有的权利除外。
            </li>
            <li>2.未经本平台或相关权利人书面同意，您不得为任何商业或非商业目的自行或许可任何第三方实施、利用、转让上述知识产权，您不得对任何该信息、资料、文字、软件、声音、图片、视频、图表进行修改、拷贝、散布、传送、展示、执行、复制、发行、授权、制作衍生著作、移转或销售。如您未遵守本条款的上述规定，将视为您的严重违约，在不损害其他权利的情况下，本平台可立即终止向您提供服务，解除双方间的服务协议和法律关系，且无需退还您在本软件平台账户金额，该金额视为您支付本平台的违约金，如违约金不足以弥补本平台的损失的，本平台还可通过其他法律途径向您追索。同时您必须销毁任何已经获得的上述信息、资料、文字、软件、声音、图片、视频、图表。
            </li>
          </ol>
          <h6>十、遵守当地法律监管</h6>
          <ol class="list decimal-list">
            <li>1.您在使用本服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。
            </li>
            <li>2.您应避免因使用本服务而使本平台卷入政治和公共事件，否则本平台有权暂停或终止对您的服务。
            </li>
            <li>3.违反本条约定，视为您的严重违约，本平台可以中止对您的服务，解除双方间的服务协议和法律关系，且无需退还您本软件平台账户金额，该金额视為您支付本平台的违约金，如违约金不足以弥补本平台的损失的，本平台还可通过其他法律途径向您追索。
            </li>
          </ol>
          <h6>十一、终端安全责任</h6>
          <ol class="list decimal-list">
            <li>1.您理解并同意，本软件同大多数互联网软件一样，可能会受多种因素影响，包括但不限于用户原因、网络服务质量、社会环境等；也可能会受各种安全问题的侵扰，包括但不限于他人非法利用用户资料，进行现实中的骚扰；用户下载安装的其他软件或访问的其他网站中可能含有病毒、木马程序或其他恶意程序，威胁您的终端设备信息和数据安全，继而影响本软件的正常使用等。因此，您应加强信息安全及个人信息的保护意识，注意密码保护，以免遭受损失。
            </li>
            <li>2.您不得制作、发布、使用、传播用于窃取本软件登录账号及他人个人信息、财产的恶意程序。
            </li>
            <li>
              3.维护软件安全与正常使用是本平台和您的共同责任，本平台将按照行业标准合理审慎地採取必要技术措施保护您的终端设备信息和数据安全，但是您承认和同意本平台并不能就此提供完全保证。
            </li>
            <li>
              4.在任何情况下，您不应轻信借款、索要密码或其他涉及财产的网络信息。涉及财产操作的，请一定先核实对方身份，并请经常留意本软件有关防范诈骗犯罪的提示。
            </li>
            <li>
              5.本软件设有网络信息安全投诉、举报制度，您可通过意见反馈界面或联系在线客服的方式进行网络信息安全的投诉与举报，本平台会及时受理并处理相关投诉和举报。
            </li>
          </ol>
          <h6>十二、未成年人保护</h6>
          <ol class="list decimal-list">
            <li>
              1.本平台非常重视对未成年人个人信息的保护。若您是18周岁以下的未成年人，在使用本服务前，应事先取得您监护人的书面同意。
            </li>
            <li>
              2.依据我国相关法律对于未成年人民事行为能力的规定，为保护未成年人在使用本软件过程中的权益，未成年人在使用本软件行为前，应事先取得家长或法定监护人（以下简称“监护人）的书面同意。若父母（监护人）希望未成年人（尤其是十岁以下子女）得以使用本软件的，必须以父母（监护人）名义申请注册，在接受本服务时，应以父母（监护人）身份开启青少年模式。
            </li>
          </ol>
          <h6>十三、通知和送达</h6>
          <ol class="list decimal-list">
            <li>
              本协议项下所有的通知均可通过重要页面公告、电子邮件、短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。
            </li>
          </ol>
          <h6>十四、其他</h6>
          <ol class="list decimal-list">
            <li>
              1.本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。
            </li>
            <li>
              2.本协议的成立、生效、履行、解释及纠纷解决，适用当地法律（不包括《法律适用法》。
            </li>
            <li>
              3.若您和本平台之间发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交本协议签订地有管辖权的人民法院管辖。
            </li>
            <li>
              4.本协议所有条款的标题仅为阅读方便，本身并无实际涵义，不能作为本协议涵义解释的依据。
            </li>
            <li>
              5.本协议条款无论因何种原因部分无效或不可执行，其余条款仍有效，对双方具有约束力。
            </li>
          </ol>
        </div>
      </div>
  
    </div>
  
  </template>
  
  <script>
  
  export default {
    data () {
      return {
        flag: 'zh_CN ',
        appname: '黑岩故事会'
      }
    },
  };
  </script>
  
  <style lang="stylus" scoped>
  .agreeWrap{
      font-size:  16px;
      padding: 15px;
      line-height: 20px;
      min-height 100vh;
      height auto;
      background: #fff;
      h1{
          font-size: 18px
      }
          h6,h4{
              padding: 15px 0;
              font-size: 16px;
              line-height: 20px
          }
          li{
              margin:  10px 0;
          }
      }
      .textIndet10{
          text-indent: 10px;
      }
      .textIndet20{
          text-indent: 15px;
      }
  </style>
  